import { Injectable } from '@angular/core';
import { WebServiceService } from '../services/web-service.service';
import { LocalStorageService } from './storage/local-storage.service';
import { getInvoiceButtonLabel } from '../utils/invoice-button-label.util';
@Injectable()
export class CompanySetupService {

  constructor(public webService: WebServiceService,public _localStorageService: LocalStorageService,) { }
  private company_setup_data:any= {is_setup:false}
  public is_setup:boolean=false
  public invoiceApprovalData:any;
  GetCompanySetUpData() {
    let req: any = {}
    this.company_setup_data = {is_setup:false}
    this.is_setup=false;
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup_data = {}
          this.company_setup_data = data.response ? data.response : {}
          this.company_setup_data.is_accepted_qty_hidden = false;
          this.company_setup_data.is_paid_price_hidden = false;
          this.company_setup_data.is_total_paid_price_hidden = false;
          this.company_setup_data.is_difference_price_hidden = false;
          this.company_setup_data.is_total_difference_price_hidden = false;
          this.company_setup_data.is_total_price_hidden = false;
          // this.company_setup_data.is_product_description_hidden = false;
          this.company_setup_data.is_product_type_hidden = false;
          this.company_setup_data.is_unit_type_hidden = false;
          this.company_setup_data.is_remarks_hidden = false;
          this.company_setup_data.is_paid_cgst_hidden = false;
          this.company_setup_data.is_paid_sgst_hidden = false;
          this.company_setup_data.is_paid_igst_hidden = false;
          this.company_setup_data.is_total_paid_price_gst_hidden = false;
          
          this.company_setup_data.enable_free_quantity_in_direct_invoice = this.company_setup_data.enable_free_quantity_in_direct_invoice ? this.company_setup_data.enable_free_quantity_in_direct_invoice : '0';
          this.company_setup_data.direct_invoice_columnList = this.company_setup_data.direct_invoice_columnList ? this.company_setup_data.direct_invoice_columnList : []
          if (this.company_setup_data.direct_invoice_columnList.length > 0) {
            this.company_setup_data.is_accepted_qty_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'accepted_qty' && v.isVisible });
            this.company_setup_data.is_paid_price_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'paid_price' && v.isVisible });
            this.company_setup_data.is_total_paid_price_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'total_paid_price' && v.isVisible });
            this.company_setup_data.is_difference_price_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'difference_price' && v.isVisible });
            this.company_setup_data.is_total_difference_price_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'total_difference_price' && v.isVisible });
            this.company_setup_data.is_total_price_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'total_price' && v.isVisible });
            // this.company_setup_data.is_product_description_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'product_description' && v.isVisible });
            this.company_setup_data.is_product_type_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'product_type' && v.isVisible });
            this.company_setup_data.is_unit_type_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'unit_type' && v.isVisible });
            this.company_setup_data.is_remarks_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'remarks' && v.isVisible });
            this.company_setup_data.is_paid_cgst_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'paid_cgst' && v.isVisible });
            this.company_setup_data.is_paid_sgst_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'paid_sgst' && v.isVisible });
            this.company_setup_data.is_paid_igst_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'paid_igst' && v.isVisible });
            this.company_setup_data.is_total_paid_price_gst_hidden = this.company_setup_data.direct_invoice_columnList.some((v) => { return v.id == 'total_paid_price_gst' && v.isVisible });
         
          }

          this.company_setup_data.in_add_invoice_accepted_qty_hidden = false;
          this.company_setup_data.in_add_invoice_paid_price_hidden = false;
          this.company_setup_data.in_add_invoice_total_paid_price_hidden = false;
          this.company_setup_data.in_add_invoice_difference_price_hidden = false;
          this.company_setup_data.in_add_invoice_total_difference_price_hidden = false;
          this.company_setup_data.in_add_invoice_total_price_hidden = false;
          this.company_setup_data.in_add_invoice_product_type_hidden = false;
          this.company_setup_data.in_add_invoice_unit_type_hidden = false;
          this.company_setup_data.in_add_invoice_remarks_hidden = false;
          this.company_setup_data.in_add_invoice_paid_cgst_hidden = false;
          this.company_setup_data.in_add_invoice_paid_sgst_hidden = false;
          this.company_setup_data.in_add_invoice_paid_igst_hidden = false;
          this.company_setup_data.in_add_invoice_total_paid_price_gst_hidden = false;
          this.company_setup_data.in_add_invoice_rejected_qty_hidden = false;

          this.company_setup_data.add_invoice_columnList = this.company_setup_data.add_invoice_columnList ? this.company_setup_data.add_invoice_columnList : []
          if (this.company_setup_data.add_invoice_columnList.length > 0) {
            this.company_setup_data.in_add_invoice_accepted_qty_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'accepted_qty' && v.isVisible });
            this.company_setup_data.in_add_invoice_paid_price_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'paid_price' && v.isVisible });
            this.company_setup_data.in_add_invoice_total_paid_price_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'total_paid_price' && v.isVisible });
            this.company_setup_data.in_add_invoice_difference_price_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'difference_price' && v.isVisible });
            this.company_setup_data.in_add_invoice_total_difference_price_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'total_difference_price' && v.isVisible });
            this.company_setup_data.in_add_invoice_total_price_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'total_price' && v.isVisible });
            this.company_setup_data.in_add_invoice_product_type_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'product_type' && v.isVisible });
            this.company_setup_data.in_add_invoice_unit_type_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'unit_type' && v.isVisible });
            this.company_setup_data.in_add_invoice_remarks_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'remarks' && v.isVisible });
            this.company_setup_data.in_add_invoice_paid_cgst_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'paid_cgst' && v.isVisible });
            this.company_setup_data.in_add_invoice_paid_sgst_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'paid_sgst' && v.isVisible });
            this.company_setup_data.in_add_invoice_paid_igst_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'paid_igst' && v.isVisible });
            this.company_setup_data.in_add_invoice_total_paid_price_gst_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'total_paid_price_gst' && v.isVisible });
            this.company_setup_data.in_add_invoice_rejected_qty_hidden = this.company_setup_data.add_invoice_columnList.some((v) => { return v.id == 'rejected_qty' && v.isVisible });

        }

          this.company_setup_data.is_setup=true
          this.is_setup=true
                }
      }, error => {

      }
    )
  }
  getData()
  {
    // console.log(this.company_setup_data);
    return this.company_setup_data?this.company_setup_data:{is_setup:false}
  }
  setData(setup)
  {
    // console.log(setup);
    this.company_setup_data=setup?setup:{is_setup:false}
    this.company_setup_data.is_setup=true;
    this.is_setup=true;
  }
  removeData()
  {
    this.company_setup_data={};
    this.company_setup_data.is_setup=false;
    this.is_setup=false;

  }

  getInvoiceButtonLabel(buttonId: string, defaultLabel: string, companySetup?: any): string {
    const setup = companySetup || this.company_setup_data;
    return getInvoiceButtonLabel(buttonId, defaultLabel, setup);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src62925525/src/src/app/shared/services/company-setup.service.ts